export default __webpack_public_path__ + "img/chat.5375f94c.svg";